module.exports = function(bootstrap) {
    bootstrap.directive('planProgress2', function() {

        return {
            restrict: 'A',
            templateUrl: 'claims.appTemplate.html/chmhom/directives/planProgress2',

            scope: {
                coverageStatus: '@planProgress2' // for refine; 'active' || 'previous'
            },

            controller: ['$scope', '$rootScope', 'services', '$q', '$filter', 'sessionData','$cookies', 'coremetrics', 'brand', 'aemContent',
                function($scope, $rootScope, services, $q, $filter, sessionData, $cookies, coremetrics, brand, aemContent) {


                    $scope.shouldShow = false;


                    var hasProducts = Boolean(services.rbsmbl.memberInfo().getUniqueProducts().length),
                        runningBreakpointTotal = 0; //PART OF TEMPORARY BREAKPOINT FIX

                    $scope.shouldShow = !sessionData.blueEdgeDentalIndv && hasProducts;

                    if ($scope.shouldShow) {

                        $scope.heading = 'plan progress';
                        $scope.coverageStatus = 'active';
                        $scope.today = $filter('date')(new Date(), 'MM/dd/yyyy');
                        $scope.hasShowableAccums = false;
                        $scope.viewState = 'loading';

                        /*Coremetrics Element Tag for Plan Progress Coremetrics Arrow link/button*/
                        $scope.planProgressArrowCoremetrics = function () {
                            coremetrics.elementTag('CLAIMS AND SPENDING:PLAN PROGRESS SUMMARY ARROW', 'MEMBER:CLAIMS AND SPENDING');
                        };


                        /* CR00606079 - suppress blue arrow/link to Health Plans for all but MINCR
                        might be implemented 2/10/17, and probably should be controlled through App Config */

                        //$scope.showPlanProgressArrow = (brand.current.sharedBrandCode.toLowerCase() == 'mincr');
                        $scope.showPlanProgressArrow = true;

                        var
                            planProgress = services.rbsmbl.planProgress().fetch(),
                            memberInfo = services.rbsmbl.memberInfo().fetch(),
                            _getDisplayGroupNumber,
                            _getBeginAndEndDate,
                            _getLobInfoMap,
                            _getPlanIcon,
                            _getLobCode,
                            _getUniqueName,
                            _mapTypeCodeObject,
                            _getSaneFamilyAccums,
                            _getUniqueMemberInfo,
                            _getSortIndex,
                            _getSubscriberFirstName,
                            _getSaneIndividualAccums,
                            _setUniqueNames,
                            _addIndividualsToFamilyAccums,
                            _setScopeViewBools,
                            _parseProgressDataList,
                            _getParsedPlanProgressData,
                            parsedPlans = {},
                            accumUtil;


                        accumUtil = (function () {
                            var
                                inNetwork = ["PHO", "PRE", "INA", "INE", "INS", "IBS", "INC", "INX", "INW", "INON", "CCA"],
                                outOfNetwork = ["ONA", "OAN", "OAC", "OAX", "OBS", "OHC", "ONC", "ONX", "ONW"],
                                otherNetwork = ["BSP", "NCA", "NPS"],

                                deductibleTypes = ["PDD", "PCD", "PDM"],
                                programMaximumTypes = ["LDM", "LBD"],
                                otherTypes = ["OOP", "TNO", "TOO", "TOP", "ORT", "BKP"],

                                descriptorCodes = [],
                                accumTypes = [];

                            inNetwork.forEach(function (item) {
                                descriptorCodes.push(item);
                            });
                            outOfNetwork.forEach(function (item) {
                                descriptorCodes.push(item);
                            });
                            otherNetwork.forEach(function (item) {
                                descriptorCodes.push(item);
                            });

                            deductibleTypes.forEach(function (item) {
                                accumTypes.push(item);
                            });
                            programMaximumTypes.forEach(function (item) {
                                accumTypes.push(item);
                            });
                            otherTypes.forEach(function (item) {
                                accumTypes.push(item);
                            });

                            var getSortIndex = function (descriptor, accumType) {
                                var descValue, accumValue;

                                accumValue = accumTypes.indexOf(accumType);
                                accumValue = (accumValue >= 0) ? accumValue * 10 : 1000;

                                descValue = descriptorCodes.indexOf(descriptor);
                                descValue = (descValue >= 0) ? descValue : 10;

                                return descValue + accumValue;
                            };

                            var shouldShowAccum = function (descriptor, accumType, achieved, threshold) {
                                var
                                    isInNetwork,
                                    isInDeductible,
                                    hasAchieved,
                                    hasThreshold;

                                descriptor = (descriptor === '')
                                    ? 'INA'
                                    : descriptor;

                                descriptor = typeof descriptor === 'string'
                                    ? descriptor.toUpperCase()
                                    : '';

                                accumType = typeof accumType === 'string'
                                    ? accumType.toUpperCase()
                                    : '';

                                // Case #0: Must have an accum type, network code, optional.
                                if (!accumType) {
                                    return false;
                                }

                                // Case #0a: If has a 0 threshold, hide it
                                hasThreshold = (parseInt(threshold, 10) > 0);
                                if (!hasThreshold) {
                                    return false;
                                }

                                isInDeductible = deductibleTypes.indexOf(accumType) >= 0 || programMaximumTypes.indexOf(accumType) >= 0;
                                isInNetwork = inNetwork.indexOf(descriptor) >= 0;

                                // Case #1: In-network deductibles always
                                if (isInNetwork && isInDeductible) {
                                    return true;
                                }

                                // Case #2: All other types only show when there are claims against them
                                //          Also, must have threshold value
                                hasAchieved = (parseInt(achieved, 10) > 0);
                                if (hasAchieved && hasThreshold) {
                                    return true;
                                }

                                // Case #3: All other combinations should be hidden
                                return false;
                            };

                            var filterDental = function (lobList) {
                                return lobList.filter(function (lob) {
                                    lob.lob = typeof lob.lob === 'string'
                                        ? lob.lob
                                        : '';

                                    return lob.lob.toLowerCase() !== 'dental';
                                });
                            };


                            return {
                                getSortIndex: getSortIndex,
                                shouldShowAccum: shouldShowAccum,
                                filterDental: filterDental
                            };
                        }());


                        _getDisplayGroupNumber = function (plan, groups) {
                            var
                                displayGroupNumber = plan.groupNumber,
                                currentGroupData;

                            for (var i = 0, len = groups.length; i < len; ++i) {
                                currentGroupData = groups[i].groupData;

                                if (currentGroupData.groupNumber === plan.groupNumber && currentGroupData.idCardEobGroupNumber) {
                                    displayGroupNumber = currentGroupData.idCardEobGroupNumber;
                                    break;
                                }
                            }
                            return displayGroupNumber;
                        };

                        _getBeginAndEndDate = function (lob, groupNumber, uniqueProducts) {
                            var
                                beginDate,
                                endDate,
                                benBeginDate,
                                benEndDate,
                                showHover;

                            for (var i = 0, product, groupData, uLen = uniqueProducts.length; i < uLen; ++i) {
                                product = uniqueProducts[i];
                                groupData = product.groupData;

                                if (groupData.groupNumber === groupNumber) {
                                    for (var j = 0, benefitPlanType, currentProduct, productList = groupData.productList, pLen = productList.length; j < pLen; ++j) {
                                        currentProduct = productList[j] || {};
                                        benefitPlanType = currentProduct.benefitPlanType || '';

                                           if (benefitPlanType.toLowerCase() === lob.toLowerCase()) {
                                            benBeginDate = currentProduct.benefitAccumulationStartDate;
                                            benEndDate = currentProduct.benefitAccumulationEndDate;
                                            if(benBeginDate){
                                                beginDate = benBeginDate;
                                                showHover = true;
                                            }else{
                                                  beginDate = currentProduct.coverageBeginDate;
                                                  showHover = false;
                                            }
                                            if(benEndDate){
                                                endDate = benEndDate;
                                            }else{
                                                 endDate = currentProduct.coverageEndDate;
                                            }                                          

                                            break;
                                        }
                                    }
                                }
                            }
                            return {
                                coverageBeginDate: beginDate || 'Not Available',
                                coverageEndDate: endDate || 'Not Available',
                                showHover : showHover
                            };
                        };

                        _getLobInfoMap = function (planType) {
                            var
                                icon,
                                lobCode,
                            //serviceLobCode,
                                sortIndex;

                            switch (planType.toLowerCase()) {
                                case 'medical':
                                    icon = 'icon-provider';
                                    lobCode = 'M';
                                    sortIndex = 1;
                                    break;
                                case 'dental':
                                    icon = 'icon-dental';
                                    lobCode = 'D';
                                    sortIndex = 2;
                                    break;
                                case 'vision':
                                    icon = 'icon-vision';
                                    lobCode = 'V';
                                    sortIndex = 3;
                                    break;
                                case 'drug':
                                    icon = 'icon-pharmacy';
                                    lobCode = 'X';
                                    sortIndex = 4;
                                    break;
                                default:
                                    icon = 'icon-provider';
                                    lobCode = 'M';
                                    sortIndex = 1;
                            }

                            return {
                                icon: icon,
                                lobCode: lobCode,
                                sortIndex: sortIndex
                            };
                        };

                        _getPlanIcon = function (planType) {
                            return _getLobInfoMap(planType).icon;
                        };

                        _getLobCode = function (planType) {
                            return _getLobInfoMap(planType).lobCode;
                        };

                        _getUniqueName = function (member, isSubscriber, subscriberFirstName) {
                            if (isSubscriber) {
                                return member.firstName.toLowerCase();
                            }
                            else if (!isSubscriber && member.firstName.toLowerCase() === subscriberFirstName.toLowerCase()) {
                                return member.firstName + ' (' + $filter('date')(member.memberDOB, 'MM/dd/yyyy') + ')';
                            }
                            else {
                                return member.firstName;
                            }
                        };

                        _mapTypeCodeObject = function (typeCodeObject, mixin) {
                            typeCodeObject = Array.isArray(typeCodeObject)
                                ? typeCodeObject
                                : [];

                            return typeCodeObject.map(function (type) {
                                var
                                    describedAccumulations = mixin
                                        ? angular.extend(type.accumDescriptorCodeObject[0], mixin)
                                        : type.accumDescriptorCodeObject[0],

                                    accumTypeCode = typeof type.accumTypeCode === 'string'
                                        ? type.accumTypeCode.toUpperCase()
                                        : '',

                                    accumDescriptorCode = typeof describedAccumulations.accumDescriptorCode === 'string'
                                        ? describedAccumulations.accumDescriptorCode.toUpperCase()
                                        : '',

                                    accumSortIndex = accumUtil.getSortIndex(accumDescriptorCode, accumTypeCode),
                                    shouldShowAccum = accumUtil.shouldShowAccum(accumDescriptorCode, accumTypeCode, describedAccumulations.accumAchieved, describedAccumulations.accumThreshold);

                                return angular.extend({
                                    accumTypeCode: accumTypeCode,
                                    accumDescriptorCode: accumDescriptorCode,
                                    accumSortIndex: accumSortIndex,
                                    shouldShow: shouldShowAccum
                                }, describedAccumulations);
                            });
                        };

                        _getSaneFamilyAccums = function (lobList, groupNumber, uniqueProducts) {
                            lobList = Array.isArray(lobList)
                                ? lobList
                                : [];

                            // immediately filter out dental
                            lobList = accumUtil.filterDental(lobList);

                            return lobList.map(function (lob) {
                                var beginAndEndDate = _getBeginAndEndDate(lob.lob, groupNumber, uniqueProducts);
                                var accumulations = lob.accumCatFObject.map(function (category) {
                                    return _mapTypeCodeObject(category.accumTypeCodeObject);
                                })[0];

                                accumulations = accumulations.filter(function (accums) {
                                    return accums.shouldShow;
                                });

                                //BEGIN TEMPORARY BREAKPOINT FIX
                                //Purpose is to check for any accums that are larger than their associated threshold and correct them.
                                //We then keep a running total of individual accums and apply that total to the family, up to the family threshold.
                                var i = 0,
                                    familyAccum;

                                for(i; i < accumulations.length; i++){
                                    familyAccum = accumulations[i];

                                    if(familyAccum.accumTypeCode === "BKP"){
                                        if(runningBreakpointTotal > Number(familyAccum.accumThreshold)){
                                           runningBreakpointTotal = Number(familyAccum.accumThreshold);
                                        }
                                        familyAccum.accumAchieved = runningBreakpointTotal.toString();
                                    }
                                }
                                //END TEMPORARY BREAKPOINT FIX

                                return {
                                    lob: lob.lob,
                                    coverageBeginDate: beginAndEndDate.coverageBeginDate,
                                    coverageEndDate: beginAndEndDate.coverageEndDate,
                                    planIcon: _getPlanIcon(lob.lob),
                                    accumulations: accumulations,
                                    hasShowable: accumulations.length > 0,
                                    showHover: beginAndEndDate.showHover
                                };
                            });
                        };

                        _getUniqueMemberInfo = function (pin, groupNumber, uniqueProducts) {
                            var
                                memberDOB,
                                isSubscriber;

                            for (var u = 0, product, uLen = uniqueProducts.length; u < uLen; ++u) {
                                product = uniqueProducts[u];
                                if (product.groupData.groupNumber === groupNumber) {
                                    for (var i = 0, currentProduct, productList = product.groupData.productList, len = productList.length; i < len; ++i) {
                                        currentProduct = productList[i];
                                        for (var j = 0, member, memberList = currentProduct.memberList, mLen = memberList.length; j < mLen; ++j) {
                                            member = memberList[j];

                                            if (pin === member.pinNumber) {
                                                memberDOB = new Date(member.contact.birthDate);
                                            }
                                            if (member.relationshipCode === '18' || member.relationshipCode === '20') {
                                                isSubscriber = true;
                                            }
                                        }
                                    }
                                }
                            }

                            return {
                                memberDOB: memberDOB,
                                isSubscriber: isSubscriber
                            };
                        };

                        _getSortIndex = function (isSubscriber, DOB) {
                            if (isSubscriber) {
                                return 0;
                            }
                            else {
                                return DOB || new Date('01/01/3000');
                            }
                        };

                        _getSubscriberFirstName = function (groupNumber, uniqueProducts) {
                            for (var u = 0, product, uLen = uniqueProducts.length; u < uLen; ++u) {
                                product = uniqueProducts[u];
                                if (product.groupData.groupNumber === groupNumber) {
                                    for (var i = 0, currentProduct, productList = product.groupData.productList, len = productList.length; i < len; ++i) {
                                        currentProduct = productList[i];
                                        for (var j = 0, member, memberList = currentProduct.memberList, mLen = memberList.length; j < mLen; ++j) {
                                            member = memberList[j];
                                            if (member.relationshipCode === '18' || member.relationshipCode === '20') {
                                                return member.contact.firstName;
                                            }
                                        }
                                    }
                                }
                            }
                        };

                        _getSaneIndividualAccums = function (lobList, groupNumber, uniqueProducts) {
                            lobList = Array.isArray(lobList)
                                ? lobList
                                : [];

                            // immediately filter out dental
                            lobList = accumUtil.filterDental(lobList);

                            return lobList.map(function (lob) {
                                var beginAndEndDate = _getBeginAndEndDate(lob.lob, groupNumber, uniqueProducts);
                                var accumulations = lob.accumCatIObject.map(function (category) {
                                    return category.accumMemberObject.map(function (member) {
                                        var
                                            uniqueMemberInfo = _getUniqueMemberInfo(member.memberPin, groupNumber, uniqueProducts),
                                            sortIndex = _getSortIndex(uniqueMemberInfo);

                                        var memberMixin = {
                                            memberPin: member.memberPin,
                                            memberFirstName: member.memberFirstName,
                                            memberLastName: member.memberLastName,
                                            memberSuffix: member.memberSuffix,
                                            memberDOB: uniqueMemberInfo.memberDOB,
                                            memberSortIndex: sortIndex
                                        };

                                        return _mapTypeCodeObject(member.accumTypeCodeObject, memberMixin);
                                    });
                                })[0];


                                for (var i = 0, accumulation, len = accumulations.length; i < len; ++i) {
                                    accumulation = accumulations[i];
                                    accumulations[i] = accumulation.filter(function (accum) {
                                        return accum.shouldShow;
                                    });
                                }
                                accumulations = accumulations.filter(function (accums) {
                                    return accums.length > 0;
                                });

                                //BEGIN TEMPORARY BREAKPOINT FIX
                                //Purpose is to check for any accums that are larger than their associated threshold and correct them.
                                //We then keep a running total of individual accums and apply that total to the family, up to the family threshold.
                                var j = 0,
                                    k,
                                    accumList,
                                    individualAccum;

                                for(j; j < accumulations.length; j++){
                                    k = 0;
                                    accumList = accumulations[j];

                                    for (k; k < accumList.length; k++){
                                        individualAccum = accumList[k];
                                        if(individualAccum.accumTypeCode === "BKP"){
                                            if(Number(individualAccum.accumAchieved) > Number(individualAccum.accumThreshold)){
                                                individualAccum.accumAchieved = individualAccum.accumThreshold;
                                            }
                                            runningBreakpointTotal += Number(individualAccum.accumAchieved);
                                        }
                                    }
                                }
                                //END TEMPORARY BREAKPOINT FIX

                                return {
                                    lob: lob.lob,
                                    coverageBeginDate: beginAndEndDate.coverageBeginDate,
                                    coverageEndDate: beginAndEndDate.coverageEndDate,
                                    planIcon: _getPlanIcon(lob.lob),
                                    accumulations: accumulations,
                                    hasShowable: accumulations.length > 0,
                                    showHover: beginAndEndDate.showHover
                                };
                            });
                        };

                        _setUniqueNames = function (accumulations) {
                            var allNames = [];
                            var pin;

                            for (var i = 0, aLen = accumulations.length; i < aLen; ++i) {
                                var member = accumulations[i];
                                member.memberUniqueName = member.memberFirstName.toLowerCase();
                                allNames.push(member.memberUniqueName);
                            }
                            for (var j = 0, nLen = allNames.length; j < nLen; ++j) {
                                var name = allNames[j];
                                if (allNames.indexOf(name) !== allNames.lastIndexOf(name)) {
                                    for (var k = 0, currentMember, mLen = accumulations.length; k < mLen; ++k) {
                                        currentMember = accumulations[k];
                                        if (currentMember.memberFirstName.toLowerCase() === name) {
                                            currentMember.memberUniqueName = name;
                                        }
                                    }
                                }
                            }
                            //for (var i = 0; i < allNames.length; i++){
                            //    if (allNames.indexOf(i) == allNames.indexOf(i+1)){
                            //        allNames.splice(i, 1);
                            //        accumulations.splice(i, 1);
                            //    }
                            //}
                            return accumulations;
                        };


                        _addIndividualsToFamilyAccums = function (family, individuals) {
                            family.forEach(function (fLob) {
                                individuals.forEach(function (iLob) {
                                    if (fLob.lob.toLowerCase() === iLob.lob.toLowerCase()) {
                                        fLob.accumulations.forEach(function (fAccum) {
                                            var individualAccumulations = [];
                                            iLob.accumulations.forEach(function (member) {
                                                member.forEach(function (mAccum) {
                                                    if (mAccum.accumTypeCode === fAccum.accumTypeCode && mAccum.accumDescriptorCode === fAccum.accumDescriptorCode) {
                                                        individualAccumulations.push(mAccum);
                                                    }
                                                });
                                            });
                                            fAccum.individualAccumulations = _setUniqueNames(individualAccumulations);
                                        });
                                    }
                                });
                            });
                            return family;

                        };

                        _setScopeViewBools = function (progressDataList) {
                            for (var i = 0, plan, len = progressDataList.length; i < len; ++i) {
                                plan = progressDataList[i];
                                if (Array.isArray(plan.family)) {
                                    for (var j = 0, fAccum, fLen = plan.family.length; j < fLen; ++j) {
                                        fAccum = plan.family[j] || {};
                                        if (fAccum.hasShowable) {
                                            $scope.hasShowableAccums = true;
                                            break;
                                        }
                                    }
                                }
                                else if (Array.isArray(plan.individuals)) {
                                    for (var k = 0, iAccum, iLen = plan.individuals.length; k < iLen; ++k) {
                                        iAccum = plan.individuals[k] || {};
                                        if (iAccum.hasShowable) {
                                            $scope.hasShowableAccums = true;
                                        }
                                    }
                                }
                            }
                        };

                        _parseProgressDataList = function (progressDataList, uniqueProducts) {
                            if (!Array.isArray(progressDataList)) {
                                $scope.viewState = 'error';
                                $scope.errorId = 'GENERALERROR';
                                return console.error('_parseProgressData was passed bad progressDataList', progressDataList);
                            }

                            var parsedProgressDataList = [];

                            parsedProgressDataList = progressDataList.map(function (plan, i) {
                                var
                                    family,
                                    individuals,
                                    displayGroupNumber;
                        //debugger; //TODO: figure out where on "plan" object the plan name is, for display
                                displayGroupNumber = _getDisplayGroupNumber(plan, uniqueProducts);

                                if (plan.lobList && plan.lobList[i] && plan.lobList[i].accumCatIObject && plan.lobList[i].accumCatIObject.length) {
                                    individuals = _getSaneIndividualAccums(plan.lobList, plan.groupNumber, uniqueProducts);
                                }

                                if (plan.lobList && plan.lobList[i] && plan.lobList[i].accumCatFObject && plan.lobList[i].accumCatFObject.length) {
                                    family = _getSaneFamilyAccums(plan.lobList, plan.groupNumber, uniqueProducts);
                                }

                                if (family && individuals) {
                                    family = _addIndividualsToFamilyAccums(family, individuals);
                                }

                                return {
                                    displayGroupNumber: displayGroupNumber,
                                    family: family,
                                    individuals: individuals
                                };
                            });

                            _setScopeViewBools(parsedProgressDataList);

                            return parsedProgressDataList;
                        };

                        _getParsedPlanProgressData = function (coverageStatus, planProgressPayload, uniqueProducts) {
                            coverageStatus = (coverageStatus === 'previous')
                                ? 'previous'
                                : 'active';

                            if (parsedPlans[coverageStatus]) {
                                return parsedPlans[coverageStatus];
                            }

                            parsedPlans[coverageStatus] = (function (cs) {
                                switch (cs) {
                                    case 'active':
                                        $scope.coverageStatus = 'active';
                                        return _parseProgressDataList(planProgressPayload.activeData, uniqueProducts);
                                    case 'previous':
                                        $scope.coverageStatus = 'previous';
                                        return _parseProgressDataList(planProgressPayload.previousData, uniqueProducts);
                                }
                            }(coverageStatus));

                            return parsedPlans[coverageStatus];
                        };

                        $scope.phoneNumber = brand.current.phoneNumbers.technical || "the number on the back of your ID card.";
                        $q.all({ memberInfo: memberInfo, planProgress: planProgress }).then(
                            function (response) {
                                var
                                    planProgressPayload = response.planProgress.data.payload,
                                    memberInfoDataPayload = response.memberInfo.data.payload,
                                    uniqueProducts = services.rbsmbl.memberInfo().getUniqueProducts(memberInfoDataPayload);

                                $scope.$watch('coverageStatus', function (cs) {
                                    $scope.planProgressData = _getParsedPlanProgressData(cs, planProgressPayload, uniqueProducts);
                                });

                                var planProgressData = response.planProgress.data || {};

                                // Check for error statuses.
                                var errorMessages = (planProgressData.baseMessage
                                    && planProgressData.baseMessage.statusMsgs
                                    && planProgressData.baseMessage.statusMsgs.messages) ?
                                        planProgressData.baseMessage.statusMsgs.messages : [];

                                var validErrors = [
                                    "MHSSVCERROR",
                                    "OSCARERROR",
                                    "ICISERROR",
                                    "ECSERROR",
                                    "SUPPRESSIONERROR"
                                ];

                                function shouldSuppressForGroup(groupNumber) {
                                    var _app = 'GLOBAL';
                                    var _key = 'SUPPRESS_PLAN_PROGRESS_BY_GROUP';
                                    
                                    var overrideValue = (sessionData
                                        && sessionData.appConfig
                                        && sessionData.appConfig[_app]
                                        && sessionData.appConfig[_app][_key]
                                        && sessionData.appConfig[_app][_key].booleanValue
                                        && sessionData.appConfig[_app][_key].overrideValue)
                                           ? sessionData.appConfig[_app][_key].overrideValue
                                           : '';

                                    overrideValue = overrideValue.replace(/\s/g, '');
                                    return overrideValue.split(',').indexOf(groupNumber) > -1;
                                }

                                if (shouldSuppressForGroup(sessionData.groupNumber)) {
                                    $scope.viewState = 'error';
                                    $scope.errorId = 'SUPPRESSIONERROR';
                                } else if (planProgressData.baseMessage.returnCode != 200) {
                                    $scope.viewState = 'error';
                                    
                                    if (planProgressData.baseMessage.returnCode == 404) {
                                        $scope.errorId = 'GENERALERROR';
                                    } else {
                                        var errorMessageFound = false;
                                        errorMessages.forEach(function (error) {
                                            if (validErrors.indexOf(error["id"]) > -1) {
                                                $scope.errorId = error["id"];
                                                return errorMessageFound = true;
                                            }
                                        });

                                        if (!errorMessageFound) {
                                            $scope.errorId = 'GENERALERROR';
                                        }
                                    }
                                } else {
                                    window.planProgScope = $scope;
                                    $scope.viewState = 'success';
                                }
                            },

                            function (err) {
                                $scope.shouldShow = true;
                                $scope.viewState = 'error';
                                $scope.errorId = 'GENERALERROR';
                            }
                        );
                    }

                    $scope.toggleAllPlansDisplay = function(){
                        $scope.isOpen = !$scope.isOpen;
                        $rootScope.$broadcast('manualResizeInStickyScroll', 500);
                    };

                    $rootScope.$on('updatePlanProgressAccums', function(event, resultAccumObj, selectedMember){
                        $scope.heading = 'estimated plan progress';
                    });
                    $rootScope.$on('recompilePlanProgressMeter', function(event){
                        $scope.heading = 'plan progress';
                    });
                }
            ]
        };
    });
};